import demetra from '@/scripts/demetra';

const actions = {
  async LOAD_BOTTLES(context) {
    const result = await demetra.ref.fetchArchive('page');
    context.commit('SAVE_BOTTLES', result);
  },

  async LOAD_BLOG(context) {
    const result = await demetra.ref.fetchArchive('post');
    context.commit('SAVE_BLOG', result);
  },
};

export default actions;
